<template>
    <v-container style="max-width:100vw; background:white;" class="pa-4">
        <!-- Filtros -->
        <v-navigation-drawer style="top: 0px; max-height:100vh!important;" right v-model="filters" :clipped="$vuetify.breakpoint.lgAndUp" app>
            <filterInvoices @filtersInvoice="filtersInvoice"/>
        </v-navigation-drawer>
        <v-toolbar flat>
            <v-toolbar-title class="">
                Facturas
                <br/>    
                <span style="font-size:12px; color:grey; position: absolute;" v-if="filterStorage">Mes Actual</span>
            </v-toolbar-title>
            <v-btn icon @click="openFilter()" class="ml-6" v-if="filterStorageLength== undefined">
                <v-icon>mdi-filter</v-icon>
            </v-btn>
            <v-btn icon class="ml-6 " v-else @click="openFilter()">
                <v-badge overlap color="primary">
                    <template v-slot:badge>
                        {{filterStorageLength}}
                    </template>
                    <v-icon>mdi-filter</v-icon>
                </v-badge>
            </v-btn>
            <v-menu bottom right>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ml-2" icon  v-bind="attrs" v-on="on">
                        <v-icon>mdi-download</v-icon>
                    </v-btn>
                </template>
                <v-list style="font-size:13px;">
                    <v-list-item @click="exportExcel(options.itemsPerPage)">
                        Exportar
                    </v-list-item>
                    <v-list-item @click="exportExcel(totalInvoices)">
                        Exportar Todo ({{totalInvoices}})
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-spacer></v-spacer>
            <!--v-btn icon @click="exportExcel">
                <v-icon>mdi-download</v-icon>
            </v-btn-->
            <v-btn class="elevation-0" color="primary" small @click="globalInvoice()" v-if="permissions('globalInvoice') && liga!='https://backendmf.unocrm.mx/'">
                Factura Global
            </v-btn>
            <v-btn class="elevation-0 ml-2" color="primary" small @click="clientGlobalInvoice=true" v-if="permissions('globalInvoice')">
                Factura Global a Cliente
            </v-btn>
            <v-btn class="elevation-0 ml-2" color="primary" small @click="openCashCustomerInvoice()" v-if="permissions('facturero')">
                Factura Global Efectivo
            </v-btn>
            <v-btn class="elevation-0 ml-2" color="primary" small @click="standaloneCreditNoteDialog=true" v-if="permissions('creditNote')">
                Generar Nota de Crédito
            </v-btn>
        </v-toolbar>
        <v-data-table  
        height="calc(100vh - 300px)"
        fixed-header
        :footer-props="{'items-per-page-options':[15, 30, 50, 100]}"
        :options.sync="options"
        :server-items-length="totalInvoices"
        :loading="loading"
        :item-class="itemRowBackground" 
        :headers="headers" 
        :items="invoices" 
        class="elevation-0 px-6 py-4">

        <template v-slot:[`item.verification_url`]="{ item }">
            <v-btn class="elevation-0" color="primary" rounded x-small :href="verification_url">Verificar</v-btn>
        </template>

        <template v-slot:[`item.collection_sale`]="{ item }">
            <v-btn small class="pa-0" text v-if="item.collection_id!=undefined" :to="{ path: '/new-collections/' + item.collection_id }">Cobranza(s) {{item.collection_id}}</v-btn>
            <v-btn small class="pa-0" text v-if="item.sale_id!=undefined" :to="{ path: '/sales/' + item.sale_id }">Venta {{item.sale_id}}</v-btn>
            <span style="font-weight: 500; letter-spacing: 0.0892857143em; font-size: 0.75rem; text-indent: 0.0892857143em; text-transform: uppercase;" v-else-if="item.type=='I'">Factura Global</span>
            <span style="font-weight: 500; letter-spacing: 0.0892857143em; font-size: 0.75rem; text-indent: 0.0892857143em; text-transform: uppercase;" v-else-if="item.type=='P'">Complemento de Pago</span>
        </template>
        
        <template v-slot:[`item.payment_form`]="{ item }">
            {{paymentForm(item.payment_form)}}
        </template>
        <template v-slot:[`item.payment_method`]="{ item }">
            {{paymentMethod(item.payment_method)}}
        </template>
        <template v-slot:[`item.type`]="{ item }">
            {{typeName(item.type)}}
        </template>
        <template v-slot:[`item.use`]="{ item }">
            {{useName(item.use)}}
        </template>
        <template v-slot:[`item.total`]="{ item }">
            {{(item.total*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
            <div style="width:75px;">
                {{new Date(item.created_at).toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).toString().slice(0, 19)}}
            </div>
        </template>
        

        <template v-slot:[`item.actions`]="{ item }">
            <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>
                <v-list style="font-size:13px;">
                    <v-list-item  v-if="permissions('cancelInvoice') && item.status!='canceled'" @click="openInvoiceCancellation(item)">
                        <v-icon small class="mr-2">
                            mdi-close
                        </v-icon>
                        Cancelar
                    </v-list-item>
                    <v-list-item  v-if="permissions('creditNote') && item.status!='canceled'" @click="invoice_to_note.dialog=true, invoice_to_note.invoice=item">
                        <v-icon small class="mr-2">
                            
                        </v-icon>
                        Nota de Crédito
                    </v-list-item>
                    <v-list-item @click="sendInvoiceEmail(item)">
                        <v-icon small class="mr-2">
                            mdi-email
                        </v-icon>
                        Enviar por Correo
                    </v-list-item>
                    <v-list-item v-if="item.type=='I'" @click="printInvoiceTicket(item.facturapi_id, item)">
                        <v-icon small class="mr-2">
                            mdi-print
                        </v-icon>
                        Imprimir Factura en Ticket
                    </v-list-item>

                    <v-list-item @click="downloadInvoice(item)">
                        <v-icon small class="mr-2">
                            mdi-download
                        </v-icon>
                        Descargar PDF
                    </v-list-item>

                    <v-list-item @click="downloadXml(item)">
                        <v-icon small class="mr-2">
                            mdi-download
                        </v-icon>
                        Descargar XML
                    </v-list-item>

                    <v-list-item v-if="(item.collection_id==undefined && item.sale_id==undefined) && item.type=='I'" @click="generateComplement(item)">
                        <v-icon small class="mr-2">
                            mdi-file-document
                        </v-icon>
                        Generar Complemento de Pago
                    </v-list-item>
                </v-list>
            </v-menu>
        </template>

        </v-data-table>
        <!-- Motivo de cancelacion -->
        <div class="text-center">
            <v-bottom-sheet  v-model="invoice_to_cancell.sheet" inset>
                <v-sheet class="text-center" :height="invoice_to_cancell.motive=='01' ?  '230px' : '160px'">
                    <div class="pt-6">
                    ¿Motivo de cancelación {{invoice_to_cancell.invoice_type=='I'?'de la factura ':'del complemento de pago '}} {{invoice_to_cancell.invoice}}?
                    </div>
                    <v-row class="mt-2">
                        <v-spacer/>
                        <v-select style="width:200px;" label="Seleccione el motivo" rounded dense outlined v-model="invoice_to_cancell.motive" :items="motives"></v-select>
                        <v-spacer/>
                    </v-row>

                    <v-row class="mt-2" v-if="invoice_to_cancell.motive=='01'">
                        <v-spacer/>
                        <v-text-field style="width:200px;" label="Folio Fiscal de la nueva factura" rounded dense outlined v-model="invoice_to_cancell.substitution"></v-text-field>
                        <v-spacer/>
                    </v-row>

                    <v-btn text color="error" @click="resetInvoiceCancellation()">
                    Salir
                    </v-btn>
                    <v-btn text color="primary" :loading="canceling" :disabled="canceling" @click="cancellInvoice()">
                    Cancelar {{invoice_to_cancell.invoice_type=='I'?' Factura ':'Complemento de Pago '}}
                    </v-btn>
                </v-sheet>
            </v-bottom-sheet>
        </div>
        <div class="text-center">
            <v-bottom-sheet v-model="saleCancelPrompt" inset>
                <v-sheet class="text-center" height="150px">
                    <div class="pt-6">
                        ¿También deseas cancelar la venta relacionada?
                    </div>
                    <v-btn class="mt-4" text color="primary" @click="openSaleCancellationDialog()">
                        Si
                    </v-btn>
                    <v-btn class="mt-4" text color="grey" @click="resetSaleCancellation()">
                        No
                    </v-btn>
                </v-sheet>
            </v-bottom-sheet>
        </div>
        <div class="text-center">
            <v-bottom-sheet v-model="saleCancelSheet" inset>
                <v-sheet class="text-center" height="150px">
                    <div class="pt-6">
                        ¿Seguro que deseas cambiar el estatus de esta venta a "Cancelación"?
                    </div>
                    <v-btn class="mt-4" text color="primary" @click="confirmSaleCancellation()">
                        Si
                    </v-btn>
                    <v-btn class="mt-4" text color="grey" @click="resetSaleCancellation()">
                        No
                    </v-btn>
                </v-sheet>
            </v-bottom-sheet>
        </div>
        <v-dialog v-model="saleRejectionDialog" max-width="800px">
            <v-card class="px-12 pb-6 pt-8 elevtion-0" style="background-color:white;">
                Motivo de Rechazo:

                <v-autocomplete
                    clearable
                    v-model="editedSale.rejection_id"
                    :items="rejectionsLists"
                    label="Motivo de Cancelación"
                    item-text="name"
                    item-value="id"
                >
                    <template slot="no-data" class="pa-2">No existen motivos relacionados.</template>
                </v-autocomplete>
                <v-textarea v-model="editedSale.rejection_comment" label="Descripcion"></v-textarea>

                <br>Inventario:<br>

                <v-list-item
                    v-for="(item, i) in editedSale.items"
                    :key="i"
                    style="border-bottom:solid 1px grey;"
                >
                    <v-list-item-content>
                        <span>{{item.quantity}} <span v-if="item.item.unit!=undefined">{{item.item.unit.name}}</span> | {{item.item.name}}</span>
                    </v-list-item-content>
                    <v-list-item-action style="width:200px!important">
                        <v-select
                            :items="merma"
                            v-model="item.rejection_status"
                            label="Merma/Devolución"
                            x-small
                            rounded
                            dense
                            outlined
                        ></v-select>
                    </v-list-item-action>
                </v-list-item>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" class="mt-3" text @click="resetSaleCancellation()">
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="blue darken-1"
                        class="mt-3"
                        text
                        @click="saveSaleRejection()"
                        :disabled="disabledSaleCancellation || process_cancelation"
                        :loading="process_cancelation"
                    >
                        Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
        <!-- Enviar factura -->
        <v-dialog v-model="invoiceEmailDialog" max-width="700px">
            <v-card v-if="invoiceEmailDialog" class="py-5">
                <v-row class="ma-0">
                    <v-spacer/>
                        <v-card-title v-if="liga=='https://backendmf.unocrm.mx/'">Correo(s) a enviar factura B-{{invoice_to_send.folio_number}}</v-card-title>
                        <v-card-title v-else>Selecciona el correo al que enviaras la factura B-{{invoice_to_send.folio_number}}</v-card-title>
                    <v-spacer/>
                </v-row>

                <v-row class="ma-0">
                    <v-spacer/>
                    <v-select small-chips v-if="liga=='https://backendmf.unocrm.mx/'" multiple label="emails" :items="mails" v-model="mails_to_send"></v-select>
                    <v-text-field v-else v-model="invoice_to_send.company.attributes.fiscal_email" label="Email"></v-text-field>
                    <v-spacer/>
                </v-row>

                <v-card-actions>
                    <v-row class="ma-0">
                        <v-spacer/>
                        <v-btn :loading="sending" :disabled="sending" @click="sendInovice()" rounded color="primary" class="elevation-0">Enviar</v-btn>
                        <v-spacer/>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogComplement" max-width="700px">
            <v-card v-if="dialogComplement" class="py-5">
                <v-row class="ma-0">
                    <v-spacer/>
                        <v-card-title>Fecha en que se recibió el pago</v-card-title>
                    <v-spacer/>
                </v-row>

                <v-row class="ma-0">
                    <v-spacer/>
                    <v-menu v-model="datePicker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field :rules="[v => !!v || 'Campo requerido']" required v-model="complement_date" label="" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker color="primary" v-model="complement_date" @input="datePicker = false"></v-date-picker>
                    </v-menu>
                    <v-spacer/>
                </v-row>

                <v-card-actions>
                    <v-row class="ma-0">
                        <v-spacer/>
                        <v-btn @click="confirmComplement()" rounded color="primary" class="elevation-0">Generar Complemento</v-btn>
                        <v-spacer/>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="filterMobile" fullscreen hide-overlay transition="dialog-bottom-transition">
            <filterInvoices style="background:white;" @filtersInvoice="filtersInvoice"/>
        </v-dialog>

        <v-dialog v-model="clientGlobalInvoice" max-width="1100px">
            <globalInvoice style="background:white;" @closeGlobalInvoiceDialog="closeGlobalInvoiceDialog"/>
        </v-dialog>

        <v-dialog v-model="printDialog" max-width="350px">
            <printInvoice @cerrarPrintInvocie="cerrarPrintInvocie" v-bind:invoice="invoice_to_print"></printInvoice>
        </v-dialog> 
        <v-dialog v-model="globalInvoiceDialog" max-width="1100px">
            <v-row class="ma-0 pa-8 pb-6" style="background:white;">
                <v-row class="ma-0" style="width:100%;">
                    <v-spacer/>
                    <v-menu offset-y :close-on-content-click="closeDatePicker(dates)">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field  clearable  outlined v-model="dates" label="Fecha" prepend-inner-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker style="min-width:443px;" v-model="dates" range></v-date-picker>
                    </v-menu>
                    <v-spacer/>
                </v-row>
                <v-col cols="3">
                    <v-card class="pa-4 elevation-0" style="background:#f4f5fb;">
                        <v-card-subtitle class="pa-0 text-center">Tarjeta de Crédito</v-card-subtitle>
                        <v-row class="ma-0 my-2" v-if="!loading_global_invoice">
                            <v-spacer/>
                            <v-card-title class="pa-0">{{(global_invoice.total_credito*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</v-card-title>
                            <v-spacer/>
                        </v-row>
                        <v-skeleton-loader class="my-4 mx-12" v-else type="text"></v-skeleton-loader>
                        <v-btn :loading="is_being_generated_credito" v-if="!loading_global_invoice" small rounded color="primary" :disabled="global_invoice.total_credito<0.01" @click="generateGlobalInvoice(6), is_being_generated_credito=true" class="elevation-0 mx-auto d-block">Generar Factura</v-btn>
                        <v-btn v-else small rounded color="primary" :disabled="true" class="elevation-0 mx-auto d-block">Generar Factura</v-btn>
                    </v-card>
                </v-col>
                <v-col cols="3">
                    <v-card class="pa-4 elevation-0" style="background:#f4f5fb;">
                        <v-card-subtitle class="pa-0 text-center">Tarjeta de Debito</v-card-subtitle>
                        <v-row class="ma-0 my-2" v-if="!loading_global_invoice">
                            <v-spacer/>
                            <v-card-title class="pa-0">{{(global_invoice.total_debito*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</v-card-title>
                            <v-spacer/>
                        </v-row>
                        <v-skeleton-loader class="my-4 mx-12" v-else type="text"></v-skeleton-loader>
                        <v-btn :loading="is_being_generated_debito" v-if="!loading_global_invoice" small rounded color="primary" :disabled="global_invoice.total_debito<0.01" @click="generateGlobalInvoice(7), is_being_generated_debito=true" class="elevation-0 mx-auto d-block">Generar Factura</v-btn>
                        <v-btn v-else small rounded color="primary" :disabled="true" class="elevation-0 mx-auto d-block">Generar Factura</v-btn>
                    </v-card>
                </v-col>
                <v-col cols="3">
                    <v-card class="pa-4 elevation-0" style="background:#f4f5fb;">
                        <v-card-subtitle class="pa-0 text-center">Efectivo</v-card-subtitle>
                        <v-row class="ma-0 my-2" v-if="!loading_global_invoice">
                            <v-spacer/>
                            <v-card-title class="pa-0">{{(global_invoice.total_efectivo*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</v-card-title>
                            <v-spacer/>
                        </v-row>
                        <v-skeleton-loader class="my-4 mx-12" v-else type="text"></v-skeleton-loader>
                        <v-btn :loading="is_being_generated_efectivo" v-if="!loading_global_invoice" small rounded color="primary" :disabled="global_invoice.total_efectivo<0.01" @click="generateGlobalInvoice(1), is_being_generated_efectivo=true" class="elevation-0 mx-auto d-block">Generar Factura</v-btn>
                        <v-btn v-else small rounded color="primary" :disabled="true" class="elevation-0 mx-auto d-block">Generar Factura</v-btn>
                    </v-card>
                </v-col>
                <v-col cols="3">
                    <v-card class="pa-4 elevation-0" style="background:#f4f5fb;">
                        <v-card-subtitle class="pa-0 text-center">Transferencia</v-card-subtitle>
                        <v-row class="ma-0 my-2" v-if="!loading_global_invoice">
                            <v-spacer/>
                            <v-card-title class="pa-0">{{(global_invoice.total_transferencia*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</v-card-title>
                            <v-spacer/>
                        </v-row>
                        <v-skeleton-loader class="my-4 mx-12" v-else type="text"></v-skeleton-loader>
                        <v-btn :loading="is_being_generated_transferencia" v-if="!loading_global_invoice" small rounded color="primary" :disabled="global_invoice.total_transferencia<0.01" @click="generateGlobalInvoice(3), is_being_generated_transferencia=true" class="elevation-0 mx-auto d-block">Generar Factura</v-btn>
                        <v-btn v-else small rounded color="primary" :disabled="true" class="elevation-0 mx-auto d-block">Generar Factura</v-btn>
                    </v-card>
                </v-col>
                <v-row class="ma-0 mt-6">
                    <v-spacer/>
                    <v-card-title v-if="!loading_global_invoice" class="pa-0">Total = {{(global_invoice.total_global*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</v-card-title>
                    <v-spacer/>
                </v-row>
            </v-row>
        </v-dialog> 
        <v-dialog v-model="cashCustomerInvoiceDialog" max-width="620px">
            <v-card class="pa-8" style="background:white;">
                <v-row class="ma-0" style="width:100%;">
                    <v-spacer/>
                    <v-menu offset-y :close-on-content-click="closeDatePicker(dates)">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field clearable outlined v-model="dates" label="Fecha" prepend-inner-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker style="min-width:443px;" v-model="dates" range></v-date-picker>
                    </v-menu>
                    <v-spacer/>
                </v-row>
                <v-select
                    v-model="cashCustomerInvoiceCustomer"
                    :items="cashCustomerInvoiceCustomers"
                    item-text="legal_name"
                    return-object
                    outlined
                    label="Cliente"
                ></v-select>
                <v-row class="ma-0">
                    <v-col cols="6" class="pl-0">
                        <v-autocomplete
                            v-model="cashCustomerInvoicePaymentForm"
                            :items="payment_forms"
                            item-text="text"
                            item-value="value"
                            outlined
                            label="Forma de Pago"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="6" class="pr-0">
                        <v-autocomplete
                            v-model="cashCustomerInvoicePaymentMethod"
                            :items="payment_methods"
                            item-text="text"
                            item-value="value"
                            outlined
                            label="Método de Pago"
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-card class="pa-4 elevation-0" style="background:#f4f5fb;">
                    <v-card-subtitle class="pa-0 text-center">Efectivo</v-card-subtitle>
                    <v-row class="ma-0 my-2" v-if="!loading_global_invoice">
                        <v-spacer/>
                        <v-card-title class="pa-0">{{(global_invoice.total_efectivo*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</v-card-title>
                        <v-spacer/>
                    </v-row>
                    <v-skeleton-loader class="my-4 mx-12" v-else type="text"></v-skeleton-loader>
                    <v-btn
                        :loading="is_being_generated_cash_customer"
                        v-if="!loading_global_invoice"
                        small
                        rounded
                        color="primary"
                        :disabled="global_invoice.total_efectivo<0.01 || cashCustomerInvoiceCustomer==null || !cashCustomerInvoicePaymentForm || !cashCustomerInvoicePaymentMethod"
                        @click="generateCashCustomerInvoice()"
                        class="elevation-0 mx-auto d-block"
                    >
                        Generar Factura
                    </v-btn>
                    <v-btn v-else small rounded color="primary" :disabled="true" class="elevation-0 mx-auto d-block">Generar Factura</v-btn>
                </v-card>
            </v-card>
        </v-dialog>
        <v-dialog v-model="invoice_to_note.dialog" max-width="900px">
            <creditNote @closeCreditNoteDialog="closeCreditNoteDialog" :invoice_to_note="invoice_to_note.invoice"/>
        </v-dialog> 
        <v-dialog v-model="standaloneCreditNoteDialog" max-width="700px">
            <standaloneCreditNote
                v-if="standaloneCreditNoteDialog"
                @closeStandaloneCreditNoteDialog="closeStandaloneCreditNoteDialog"
            />
        </v-dialog>
    </v-container>
</template>

<script>
import axios from 'axios';
import XLSX from 'xlsx';
import fiscal_catalogs from '../../mixins/fiscal_catalogs'
import filterInvoices from '../invoices/filters'
import PrintInvoice from "../ferreteria/invoice"
import creditNote from "../invoices/creditNote"
import standaloneCreditNote from "../invoices/standaloneCreditNote"
import globalInvoice from "../invoices/globalInvoice.vue"
const AUTH_HEADER = 'Bearer ' + localStorage.getItem("xn8(*&^%$#47b*g3f76gw3*&^fn734gf8q*&^&^&mwmeg934g8whmre7ngN&G#*!NG@*&#GF(!*#gm1n428fm1g3n84gmf*^$&(%$)e3298negmg");
export default {
    invoiceEmailDialog:false,
    mixins: [fiscal_catalogs],
    components: {
        filterInvoices:filterInvoices,
        'printInvoice':PrintInvoice,
        creditNote:creditNote,
        standaloneCreditNote:standaloneCreditNote,
        'globalInvoice':globalInvoice
    },
    data: () => ({
        standaloneCreditNoteDialog:false,
        clientGlobalInvoice:false,
        cashCustomerInvoiceDialog:false,
        cashCustomerInvoiceCustomer:null,
        cashCustomerInvoicePaymentForm:'01',
        cashCustomerInvoicePaymentMethod:'PUE',
        is_being_generated_cash_customer:false,
        cashCustomerInvoiceCompanyIds:[2007, 546],
        cashCustomerInvoiceCustomers:[],
        mails:[],
        mails_to_send:[],
        canceling:false,
        datePicker:false,
        complement_date:new Date().toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).toString().slice(0, 10),
        dialogComplement:false,
        complement:undefined,
        globalInvoiceDialog:false,
        printDialog:false,
        invoice_to_print:{},
        invoice_to_send:{},
        fiscal_email:'',
        invoiceEmailDialog:false,
        options: {},
        loading: true,
        snackbar: {
            show: false,
            message: null,
            color: null
        },
        invoice_to_send:{},
        sheet: false,
        filters: false,
        filterMobile: false,
        invoices:[],
        
        filterStorageLength:0,
        totalInvoices:0,
        merma:['Merma', 'Devolución'],
        process_cancelation:false,
        saleCancelPrompt:false,
        saleCancelSheet:false,
        saleRejectionDialog:false,
        sale_to_cancel_id:null,
        editedSale:{
            id:'',
            status:'',
            rejection_comment:'',
            rejection_id:'',
            items: [],
            last_updated_by_user_id:'',
            facturapi_receipt_id:undefined,
            facturapi_invoices:[]
        },
        motives:[
            {value:'01', text:'Comprobante emitido con errores con relación'},
            {value:'02', text:'Comprobante emitido con errores sin relación'},
            {value:'03', text:'No se llevó a cabo la operación'},
            {value:'04', text:'Operación nominativa relacionada en la factura global'},
        ],
        invoice_to_cancell:{
            invoice_type:'',
            motive: '',
            invoice: '',
            sheet: false,
            substitution:undefined,
            sale_id:null
        },
        invoice_to_note:{
            invoice: '',
            dialog: false,
        },
        loading_global_invoice:true,
        global_invoice:undefined,
        is_being_generated_credito:false,
        is_being_generated_debito:false,
        is_being_generated_efectivo:false,
        is_being_generated_transferencia:false,
        dates:[new Date().toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).slice(0,10), new Date().toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).slice(0,10)]
    }),
    watch: {
        options: {
            handler () {
                this.getDataFromApi()
            },
            deep: true,
        },
        dates: {
            handler () {
                console.log(this.dates)
                if((this.dates.length==2 || this.dates.length==null) && (this.globalInvoiceDialog || this.cashCustomerInvoiceDialog)){
                    this.loadGlobalInvoiceTotals()
                }
            },
            deep: true
        }
    },
    computed:{
        disabledSaleCancellation(){
            for(let i = 0; i < this.editedSale.items.length; i++){
                if(this.editedSale.items[i].rejection_status == null){
                    return true
                }
            }
            return false
        },
        headers(){
            return [
                {text:'Folio Factura', value:'folio_number'},
                {text:'Fecha', value:'date'},
                {text:'Cliente', value:'company.attributes.razon_social'},
                {text:'Venta / Cobranza', value:'collection_sale'},
                {text:'Condiciones de Pago', value:'conditions'},
                {text:'Forma de Pago', value:'payment_form'},
                {text:'Metodo de Pago', value:'payment_method'},
                {text:'Serie', value:'series'},
                {text:'Status', value:'status'},
                {text:'Monto', value:'total'},
                {text:'Tipo', value:'type'},
                {text:'Uso de CFDI', value:'use'},
                {text:'Status de Cancelación', value:'cancellation_status'},
                //{text:'Verificación', value:'verification_url'},
                this.liga == 'https://backendmf.unocrm.mx/' ? {text:'Creación', value:'created_at'} : '',
                {value:'actions', sortable:false},
            ]   
        },
        liga(){
            return process.env.VUE_APP_BACKEND_ROUTE
        },
        filterStorage(){
            if(localStorage.getItem('filtersInvoices')!=null){
                false
            }else{
                return true
            }
        },
        currentUser(){
            return this.$store.state.currentUser.user
        },
        rejectionsLists(){
            return this.$store.state.rejection.rejections
        }
    },
    methods: {
        openInvoiceCancellation(item){
            this.invoice_to_cancell = {
                invoice_type: item.type,
                motive: '',
                invoice: item.facturapi_id,
                sheet: true,
                substitution: undefined,
                sale_id: item.sale_id || item.sale?.id || null
            }
        },
        resetInvoiceCancellation(){
            this.invoice_to_cancell = {
                invoice_type:'',
                motive: '',
                invoice: '',
                sheet: false,
                substitution: undefined,
                sale_id: null
            }
            this.canceling = false
        },
        resetSaleCancellation(){
            this.saleCancelPrompt = false
            this.saleCancelSheet = false
            this.saleRejectionDialog = false
            this.process_cancelation = false
            this.sale_to_cancel_id = null
            this.editedSale = {
                id:'',
                status:'',
                rejection_comment:'',
                rejection_id:'',
                items: [],
                last_updated_by_user_id:'',
                facturapi_receipt_id:undefined,
                facturapi_invoices:[]
            }
        },
        openSaleCancellationDialog(){
            if(this.sale_to_cancel_id == null){
                this.resetSaleCancellation()
                return
            }
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/sales?filter[id]=" + this.sale_to_cancel_id).then(response => {
                const sale = response.data.data[0]
                if(sale == undefined){
                    this.snackbar = {
                        message: 'No se encontró la venta relacionada',
                        color: 'red',
                        show: true
                    }
                    this.resetSaleCancellation()
                    return
                }
                if(sale.status == 'cancelled'){
                    this.snackbar = {
                        message: 'La venta ya está cancelada',
                        color: 'warning',
                        show: true
                    }
                    this.resetSaleCancellation()
                    return
                }
                this.editedSale = {
                    id: sale.id,
                    status: 'cancelled',
                    rejection_comment:'',
                    rejection_id:'',
                    items: (sale.items || []).map(item => {
                        return {
                            cost: item.cost,
                            id: item.id,
                            item: item.item,
                            price: item.price,
                            quantity: item.quantity,
                            quotation: item.quotation,
                            rejection_status: item.rejection_status,
                            value: item.value,
                            is_in_production: sale.is_in_production,
                            production_dispatched: sale.production_dispatched,
                            discount: item.discount
                        }
                    }),
                    last_updated_by_user_id:'',
                    facturapi_receipt_id: sale.facturapi_receipt_id,
                    facturapi_invoices: sale.facturapi_invoices || []
                }
                this.saleCancelPrompt = false
                this.saleRejectionDialog = true
            }).catch(error => {
                this.snackbar = {
                    message: error.response?.data?.message || 'Error al cargar la venta relacionada',
                    color: 'red',
                    show: true
                }
                this.resetSaleCancellation()
            })
        },
        saveSaleRejection(){
            this.saleCancelSheet = true
        },
        confirmSaleCancellation(){
            this.process_cancelation = true
            this.editedSale.last_updated_by_user_id = this.currentUser.id
            axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/sale/cancel", Object.assign(this.editedSale)).then(() => {
                const config = {
                    headers: {
                        'Authorization': "Bearer " + localStorage.getItem("xn8(*&^%$#47b*g3f76gw3*&^fn734gf8q*&^&^&mwmeg934g8whmre7ngN&G#*!NG@*&#GF(!*#gm1n428fm1g3n84gmf*^$&(%$)e3298negmg")
                    }
                }
                const activeInvoices = (this.editedSale.facturapi_invoices || []).filter(invoice => invoice.status != "canceled")
                if(activeInvoices.length > 0){
                    let index = 0
                    const sendRequests = () => {
                        if(index >= activeInvoices.length){
                            this.snackbar = {
                                message: 'Venta cancelada con éxito',
                                color: 'success',
                                show: true
                            }
                            this.getDataFromApi()
                            this.resetSaleCancellation()
                            return
                        }
                        axios.delete(`${process.env.VUE_APP_BACKEND_ROUTE}api/v2/facturapi/invoices/${activeInvoices[index].facturapi_id}`, config).then(() => {
                            index++
                            setTimeout(sendRequests, 1000)
                        }).catch(error => {
                            this.snackbar = {
                                message: error.response?.data?.message || 'Error al cancelar la factura relacionada',
                                color: 'red',
                                show: true
                            }
                            this.process_cancelation = false
                        })
                    }
                    sendRequests()
                }else if(this.editedSale.facturapi_receipt_id != undefined){
                    axios.delete(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/facturapi/receipts/" + this.editedSale.facturapi_receipt_id, config).then(() => {
                        this.snackbar = {
                            message: 'Venta cancelada con éxito',
                            color: 'success',
                            show: true
                        }
                        this.getDataFromApi()
                        this.resetSaleCancellation()
                    }).catch(error => {
                        this.snackbar = {
                            message: error.response?.data?.message || 'Error al cancelar el recibo relacionado',
                            color: 'red',
                            show: true
                        }
                        this.process_cancelation = false
                    })
                }else{
                    this.snackbar = {
                        message: 'Venta cancelada con éxito',
                        color: 'success',
                        show: true
                    }
                    this.getDataFromApi()
                    this.resetSaleCancellation()
                }
            }).catch(error => {
                this.snackbar = {
                    message: error.response?.data?.message || 'Error al cancelar la venta',
                    color: 'red',
                    show: true
                }
                this.process_cancelation = false
            })
        },
        downloadInvoice(invoice){
            console.log('perro')
            if((this.liga == 'https://backendmf.unocrm.mx/' || this.liga == 'http://127.0.0.1:8000/') && invoice.type=='I'){
                let config = {
                    responseType: 'arraybuffer',
                    headers: {
                        'Authorization': "Bearer " + localStorage.getItem("xn8(*&^%$#47b*g3f76gw3*&^fn734gf8q*&^&^&mwmeg934g8whmre7ngN&G#*!NG@*&#GF(!*#gm1n428fm1g3n84gmf*^$&(%$)e3298negmg"),
                        'Content-Type': 'application/json',
                        'Accept': 'application/pdf'
                    }
                }
                axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/custom-invoice/", { "invoice_id":invoice.facturapi_id}, config).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', invoice.uuid+ '.pdf'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
            }else{
                let config = {
                    responseType: 'arraybuffer',
                    headers: {
                        'Authorization': "Bearer " + localStorage.getItem("xn8(*&^%$#47b*g3f76gw3*&^fn734gf8q*&^&^&mwmeg934g8whmre7ngN&G#*!NG@*&#GF(!*#gm1n428fm1g3n84gmf*^$&(%$)e3298negmg"),
                        'Content-Type': 'application/json',
                        'Accept': 'application/pdf'
                    }
                }
                axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/facturapi/invoices/" + invoice.facturapi_id + '/pdf', config).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', invoice.uuid+ '.pdf'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
            }
        },
        downloadXml(invoice){
            let config = {
                responseType: 'arraybuffer',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("xn8(*&^%$#47b*g3f76gw3*&^fn734gf8q*&^&^&mwmeg934g8whmre7ngN&G#*!NG@*&#GF(!*#gm1n428fm1g3n84gmf*^$&(%$)e3298negmg"),
                    'Content-Type': 'application/json',
                    'Accept': 'application/xml'
                }
            }
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/facturapi/invoices/" + invoice.facturapi_id + '/xml', config).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', invoice.uuid+ '.xml'); //or any other extension
                document.body.appendChild(link);
                link.click();
            })
        },
        closeDatePicker(dates){
            if(dates!=undefined && dates.length==2){
                return true
            }else{
                return false
            }
        },
        permissions(permission){
            if(this.currentUser.id==1){
                return true
            }else if(this.currentUser.permissions!=undefined){
                if(this.currentUser.permissions.includes(permission)){
                    return true
                }else{
                    return false
                }
            }else{
                return false
            }
        },
        generateGlobalInvoice(methodId){
            var filter = ''
            if(this.dates.length == 2){
                filter = '&date1=' + this.dates[0] + '&date2=' + this.dates[1]
            }
            axios.post(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/global-invoices/make-credit?methodId=' + methodId + filter).then(response=>{
                /*let config2 = {
                    responseType: 'arraybuffer',
                    headers: {
                        'Authorization': "Bearer" + localStorage.getItem("xn8(*&^%$#47b*g3f76gw3*&^fn734gf8q*&^&^&mwmeg934g8whmre7ngN&G#*!NG@*&#GF(!*#gm1n428fm1g3n84gmf*^$&(%$)e3298negmg"),
                        'Content-Type': 'application/json',
                        'Accept': 'application/pdf'
                    }
                }
                var invoice = response.data
                axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/facturapi/invoices/" + invoice.facturapi_id + '/pdf', config2).then((resp) => {
                    const url = window.URL.createObjectURL(new Blob([resp.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', invoice.uuid + '.pdf');
                    document.body.appendChild(link);
                    link.click();*/
                    this.globalInvoice()
                    this.snackbar = {
                        message: 'Factura generada con éxito',
                        color: 'success',
                        show: true
                    }
                    this.is_being_generated_credito = false
                    this.is_being_generated_debito = false
                    this.is_being_generated_efectivo = false
                    this.is_being_generated_transferencia = false
                    this.getDataFromApi()
                //})
            })
        },
        openCashCustomerInvoice(){
            this.cashCustomerInvoiceDialog = true
            this.cashCustomerInvoiceCustomer = null
            this.cashCustomerInvoicePaymentForm = '01'
            this.cashCustomerInvoicePaymentMethod = 'PUE'
            this.loadCashCustomerInvoiceCustomers()
            this.loadGlobalInvoiceTotals()
        },
        loadCashCustomerInvoiceCustomers(){
            Promise.all(this.cashCustomerInvoiceCompanyIds.map(companyId => {
                return axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/companies/' + companyId)
            })).then(responses => {
                this.cashCustomerInvoiceCustomers = responses.map(response => {
                    const company = response.data.data
                    return {
                        id: company.id,
                        ...company.attributes,
                        legal_name: company.attributes.razon_social || company.attributes.name
                    }
                })
            }).catch(error => {
                this.snackbar = {
                    message: error.response?.data?.message || 'No se pudieron cargar los clientes de factura global efectivo.',
                    color: 'red',
                    show: true
                }
            })
        },
        generateCashCustomerInvoice(){
            const customer = this.cashCustomerInvoiceCustomer
            if(!customer || !customer.id){
                this.snackbar = {
                    message: 'Selecciona un cliente válido para generar la factura.',
                    color: 'red',
                    show: true
                }
                return
            }
            if(!this.cashCustomerInvoicePaymentForm || !this.cashCustomerInvoicePaymentMethod){
                this.snackbar = {
                    message: 'Selecciona forma y método de pago.',
                    color: 'red',
                    show: true
                }
                return
            }
            var filter = ''
            if(this.dates.length == 2){
                filter = '&date1=' + this.dates[0] + '&date2=' + this.dates[1]
            }
            this.is_being_generated_cash_customer = true
            axios.post(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/global-invoices/make-credit?methodId=1' + filter, {
                company_id: customer.id,
                require_customer: true,
                payment_form: this.cashCustomerInvoicePaymentForm,
                payment_method: this.cashCustomerInvoicePaymentMethod
            }).then(() => {
                this.cashCustomerInvoiceDialog = false
                this.snackbar = {
                    message: 'Factura generada con éxito',
                    color: 'success',
                    show: true
                }
                this.is_being_generated_cash_customer = false
                this.loadGlobalInvoiceTotals()
                this.getDataFromApi()
            }).catch(error => {
                this.snackbar = {
                    message: error.response?.data?.message || 'Error al generar la factura',
                    color: 'red',
                    show: true
                }
                this.is_being_generated_cash_customer = false
            })
        },
        globalInvoice(){
            this.globalInvoiceDialog = true
            this.loadGlobalInvoiceTotals()
        },
        loadGlobalInvoiceTotals(){
            this.loading_global_invoice = true
            var filter = ''
            if(this.dates.length == 2){
                filter = '?date1=' + this.dates[0] + '&date2=' + this.dates[1]
            }
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/global-invoices' + filter).then(response=>{
                this.loading_global_invoice = false
                this.global_invoice = response.data
            })
        },
        printInvoiceTicket(facturapi_id, invoice){
            let config = {
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("xn8(*&^%$#47b*g3f76gw3*&^fn734gf8q*&^&^&mwmeg934g8whmre7ngN&G#*!NG@*&#GF(!*#gm1n428fm1g3n84gmf*^$&(%$)e3298negmg"), 
                    'Content-Type': "application/json"
                }
            }
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/facturapi/invoices/" + facturapi_id, config).then(response=>{
                this.invoice_to_print = response.data
                this.invoice_to_print.sale = invoice.sale
                this.printDialog = true
            })
        },
        closeCreditNoteDialog: function(params){
            this.invoice_to_note.dialog = false
            this.invoice_to_note.invoice = ''
        },
        closeStandaloneCreditNoteDialog: function(refresh){
            this.standaloneCreditNoteDialog = false
            if(refresh){
                this.snackbar = {
                    message: 'Nota de crédito generada con éxito',
                    color: 'success',
                    show: true
                }
                this.getDataFromApi()
            }
        },
        cerrarPrintInvocie: function(params){
            this.printDialog = false
        },
        filtersInvoice: function(params) {
            this.getDataFromApi()
            this.showTable = false
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                this.filterMobile = false
            }
            this.$nextTick(() => {
                this.showTable = true
            })
        },
        closeGlobalInvoiceDialog: function(params){
            this.clientGlobalInvoice = false
            this.snackbar = {
                message: 'Factura generada con éxito',
                color: 'success',
                show: true
            }
            if(params){
                this.getDataFromApi()
            }
        },
        cancellInvoice(){
            this.canceling = true
            const selectedInvoice = this.invoices.find(invoice => invoice.facturapi_id == this.invoice_to_cancell.invoice)
            let config = {
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("xn8(*&^%$#47b*g3f76gw3*&^fn734gf8q*&^&^&mwmeg934g8whmre7ngN&G#*!NG@*&#GF(!*#gm1n428fm1g3n84gmf*^$&(%$)e3298negmg")
                },
                params: {
                    motive: this.invoice_to_cancell.motive,
                    substitution: this.invoice_to_cancell.substitution
                },
            }
            axios.delete(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/facturapi/invoices/" + this.invoice_to_cancell.invoice, config).then((resp) => {
                var invoice = {
                    cancellation_status: 'pending',
                    status: 'canceled'
                }
                axios.patch(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/invoices/" + this.invoices.filter(invoice=>invoice.facturapi_id == this.invoice_to_cancell.invoice)[0].id, invoice).then(response => {
                    this.invoices.filter(invoice=>invoice.facturapi_id == this.invoice_to_cancell.invoice)[0].cancellation_status = 'pending'
                    this.invoices.filter(invoice=>invoice.facturapi_id == this.invoice_to_cancell.invoice)[0].status = 'canceled'
                    this.snackbar = {
                        message: 'Factura cancelada con éxito',
                        color: 'success',
                        show: true
                    }
                    const saleId = selectedInvoice?.sale_id || selectedInvoice?.sale?.id || this.invoice_to_cancell.sale_id
                    this.resetInvoiceCancellation()
                    if(saleId != null){
                        this.sale_to_cancel_id = saleId
                        this.saleCancelPrompt = true
                    }
                })
            }).catch(error=>{
                this.snackbar = {
                    message: error.response?.data?.message || 'Error al cancelar la factura',
                    color: 'red',
                    show: true
                }
                this.canceling = false
            })
        },
        sendInvoiceEmail(item){
            this.mails = [item.sale.company.attributes.fiscal_email, item.sale.company.attributes.email].concat(this.$store.state.contact.contacts.filter(contact=>contact.company_id == item.sale.company.attributes.company_id).map(c=>c.email))
            this.invoiceEmailDialog = true
            this.invoice_to_send = item
        },
        sendInovice(){
            this.sending=true
            if(this.liga=='https://backendmf.unocrm.mx/'){
                axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/custom-invoice",{
                    "invoice_id": this.invoice_to_send.facturapi_id,
                    "emails": this.mails_to_send
                }).then(response=>{
                    this.snackbar = {
                        message: 'Factura enviada con éxito',
                        color: 'success',
                        show: true
                    }
                    this.invoiceEmailDialog = false
                    this.invoice_to_send = {}
                    this.sending=false
                }).catch(error=>{
                    this.snackbar = {
                        message: error.response.data.message,
                        color: 'red',
                        show: true
                    }
                    this.sending=false
                })
            }else{
                let config = {
                    headers: {
                        'Authorization': "Bearer " + localStorage.getItem("xn8(*&^%$#47b*g3f76gw3*&^fn734gf8q*&^&^&mwmeg934g8whmre7ngN&G#*!NG@*&#GF(!*#gm1n428fm1g3n84gmf*^$&(%$)e3298negmg")
                    }
                }
                axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/facturapi/invoices/" + this.invoice_to_send.facturapi_id + '/email', {email: this.fiscal_email},config).then((resp) => {
                    this.snackbar = {
                        message: 'Factura enviada con éxito',
                        color: 'success',
                        show: true
                    }
                    this.invoiceEmailDialog = false
                    this.invoice_to_send = {}
                    this.sending=false
                }).catch(error=>{
                    this.snackbar = {
                        message: error.response.data.message,
                        color: 'red',
                        show: true
                    }
                    this.sending=false
                })
            }
        },
        paymentForm(item){
            return this.payment_forms.filter(form=>form.value == item).map(form=>form.value + ' | ' + form.text)[0]
        },
        paymentMethod(item){
            return this.payment_methods.filter(method=>method.value == item).map(method=>method.value + ' | ' + method.text)[0]
        },
        typeName(item){
            switch(item){
                case 'I': return 'Factura'
                case 'P': return 'Complemento de Pago'
                case 'E': return 'Egreso'
                case 'N': return 'Nomina'
                case 'T': return 'Traslado'
            }
        },
        useName(item){
            return this.$store.state.cfdi.uses.filter(use=>use.Clave == item).map(use=>use.Clave + ' | ' + use.Descripción)[0]
        },
        buildFilterParams(extraParams = {}) {
            let params = [];

            // ✅ Filtros almacenados en localStorage
            const savedFilters = localStorage.getItem('filtersInvoices');
            if (savedFilters) {
            const parsed = JSON.parse(savedFilters);
            for (const key in parsed) {
                if (parsed[key] !== null && parsed[key] !== '') {
                params.push(`${encodeURIComponent(key)}=${encodeURIComponent(parsed[key])}`);
                }
            }
            }

            // ✅ Filtros adicionales (por ejemplo filtros desde el drawer)
            if (this.company) {
            params.push(`filter[company_id]=${encodeURIComponent(this.company)}`);
            }

            // ✅ Ordenamiento
            if (this.options.sortBy?.length === 1) {
            const field = this.options.sortBy[0];
            const desc = this.options.sortDesc?.[0];
            params.push(`sort=${desc ? '-' + field : field}`);
            }

            // ✅ Paginación
            if (this.options.page) {
            params.push(`page=${this.options.page}`);
            }
            if (this.options.itemsPerPage) {
            params.push(`itemsPerPage=${this.options.itemsPerPage}`);
            }

            // ✅ Parámetros extras que se pasen a la función
            for (const key in extraParams) {
            if (extraParams[key] !== undefined && extraParams[key] !== null) {
                params.push(`${encodeURIComponent(key)}=${encodeURIComponent(extraParams[key])}`);
            }
            }

            // Retorna en formato &key=value
            return params.length ? '&' + params.join('&') : '';
        },
        async exportExcel ( itemsPerPage ) {
            const { sortBy, sortDesc, page } = this.options;

            // Construimos los params igual que en apiCall
            const params = {
                page,
                itemsPerPage,
                export: true,
            };

            // Filtro por compañía (igual que en apiCall)
            if (this.company != null && this.company !== undefined) {
                params['filter[company_id]'] = this.company;
            }

            // Filtros guardados en localStorage (soporta string de query o JSON)
            const stored = localStorage.getItem('filtersInvoices');
            if (stored) {
                try {
                const parsed = JSON.parse(stored);
                if (parsed && typeof parsed === 'object') {
                    Object.entries(parsed).forEach(([k, v]) => { params[k] = v; });
                } else if (typeof parsed === 'string') {
                    new URLSearchParams(parsed).forEach((v, k) => { params[k] = v; });
                }
                } catch (_e) {
                // No era JSON, tratamos como query string plano
                new URLSearchParams(stored).forEach((v, k) => { params[k] = v; });
                }
            }

            // Ordenamiento (igual que en apiCall)
            if (Array.isArray(sortBy) && sortBy.length === 1 &&
                Array.isArray(sortDesc) && sortDesc.length === 1) {
                params.sort = `${sortDesc[0] ? '-' : ''}${sortBy[0]}`;
            }

            const url = `${process.env.VUE_APP_BACKEND_ROUTE}api/v2/invoice`; // OJO: plural
            const config = {
                responseType: 'blob',
                headers: {
                    Authorization: AUTH_HEADER,
                    Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                },
                params,
            };

            const response = await axios.get(url, config);
            this.downloadFile(response.data, `report.xlsx`);
        },

        downloadFile(blobData, filename) {
            const url = window.URL.createObjectURL(new Blob([blobData]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        },
        openFilter(){
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                this.filterMobile = true
            }else{
                if(this.filters == false){
                    this.$emit("closeDrawer", false);
                    this.filters = true
                }else{
                    this.$emit("closeDrawer", true);
                    this.filters = false
                }
            }
        },
        itemRowBackground: function (item) {
            switch(item.type){
                case 'I': return 'white'
                case 'P': return '#f4f5fb'
                case 'E': return ''
                case 'N': return ''
                case 'T': return ''
            }
        },
        getDataFromApi () {
            this.loading = true
            this.apiCall().then(data => {
                this.invoices = data.invoices
                this.totalInvoices = data.total
                this.loading = false
            })
        },
        apiCall () {
            return new Promise((resolve, reject) => {
                this.filterStorageLength = localStorage.getItem('filtersInvoicesLength')
                const { sortBy, sortDesc, page, itemsPerPage } = this.options
                var invoices = []
                var total = 0
                var link = ''
                if(this.company!=undefined){
                    link = link + 'filter[company_id]='+this.company+'&'
                }
                if(localStorage.getItem('filtersInvoices')!=null&&localStorage.getItem('filtersInvoices')!=undefined){
                    link = link + JSON.parse(localStorage.getItem('filtersInvoices'))+'&'
                }
                if (sortBy.length === 1 && sortDesc.length === 1) {
                        if(sortDesc[0]){
                            link = "&sort=-" + sortBy[0]
                        }else{
                            link = "&sort=" + sortBy[0]
                        }
                }
                if(this.$route.params.id!=undefined){
                    link = link + 'filter[id]='+this.$route.params.id+'&'
                }
                axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/invoices?" + link + "page=" + page + "&itemsPerPage=" + itemsPerPage).then(response => {
                    invoices = this.mapInvoices(response.data.data)
                    total = response.data.meta.total
                    resolve({
                        invoices,
                        total,
                    })
                })
            })
        },
        mapInvoices(invoices){
            return invoices
        },
        generateComplement(element){
            if(this.isPueInvoice(element)){
                this.snackbar = {
                    message: 'No se puede generar complemento de pago para una factura PUE.',
                    color: 'error',
                    show: true
                }
                return
            }

            this.complement = element
            this.dialogComplement = true
        },
        isPueInvoice(invoice){
            return String(invoice?.payment_method || '').trim().toUpperCase() === 'PUE'
        },
        paymentComplementTaxBase(invoice, rate){
            const subtotal = Number(invoice.subtotal || invoice.sale?.subtotal || 0)
            if (subtotal > 0) {
                return Number(subtotal.toFixed(2))
            }

            const total = Number(invoice.total || 0)
            if (total <= 0) {
                return 0
            }

            return Number((rate > 0 ? total / (1 + rate) : total).toFixed(2))
        },
        confirmComplement(){
            if(this.isPueInvoice(this.complement)){
                this.snackbar = {
                    message: 'No se puede generar complemento de pago para una factura PUE.',
                    color: 'error',
                    show: true
                }
                return
            }

            const invoice = [this.complement].map(id=>{return{
                //date: this.complement_date,
                type:"P",
                customer:id.facturapi_customer_id,
                complements:[{
                    type:"pago",
                    data:[{
                        payment_form: id.payment_form,
                        related_documents: [{
                            uuid: id.uuid,
                            amount: id.total,
                            taxes: process.env.VUE_APP_BACKEND_ROUTE == 'https://backendmf.unocrm.mx/' ? [{
                                type: "IVA",
                                rate: 0,
                                base: this.paymentComplementTaxBase(id, 0)
                            }] : [{
                                type: "IVA",
                                rate: 0.16,
                                base: this.paymentComplementTaxBase(id, 0.16)
                            }],
                            installment: 1,
                            last_balance: id.total
                        }],
                        date: this.complement_date
                    }],
                }],
                //external_id:id.id,
                series: process.env.VUE_APP_BACKEND_ROUTE == 'https://backendmf.unocrm.mx/' ? 'CEDIS':'Serie A'
            }})[0]
            let config = {
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("xn8(*&^%$#47b*g3f76gw3*&^fn734gf8q*&^&^&mwmeg934g8whmre7ngN&G#*!NG@*&#GF(!*#gm1n428fm1g3n84gmf*^$&(%$)e3298negmg"),
                    'Content-Type': "application/json"
                }
            }
            axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/facturapi/invoices", invoice, config).then(response => {
                const facturapi = response.data
                const sale = {
                    facturapi_id: facturapi.id,
                    organization: facturapi.organization,
                    date: facturapi.created_at.toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).toString().slice(0, 19),
                    type: facturapi.type,
                    uuid: facturapi.uuid,
                    use: facturapi.use,
                    folio_number:facturapi.folio_number,
                    //payment_form: facturapi.payment_form,
                    //payment_method: facturapi.payment_method,
                    //sale_id: facturapi.external_id,
                    //conditions: facturapi.conditions,
                    cfdi_version: facturapi.cfdi_version,
                    facturapi_customer_id: facturapi.customer_id,
                    verification_url: facturapi.verification_url,
                    status: facturapi.status,
                    cancellation_status: facturapi.cancellation_status,
                    total: facturapi.total,
                    series: facturapi.series,                    
                    collection_id: facturapi.external_id,
                    /* al tiro, quien sabe porque salen en la respuesta estos
                    items:[{
                        discount: 0
                        product: {
                            description: "Pago"
                            price: 0
                            product_key: "84111506"
                            taxes: []
                            unit_key: "ACT"
                            unit_name: "Actividad"
                        }
                        quantity: 1
                    }]*/
                }
                axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/invoices", sale).then(response => {
                    this.snackbar = {
                        message: 'Complemento de pago generada con éxito',
                        color: 'success',
                        show: true
                    }
                    this.dialogComplement = false
                    this.complement_date=undefined
                    this.complement=undefined
                })
            }).catch(error => {
                this.snackbar = {
                    message: error.response.data.message,
                    color: 'error',
                    show: true
                }
            })
        }
    }
}
</script>

<style>
.v-card-title.text-center {
  text-align: center!important;
}
</style>
